export var RegistrationStep;
(function (RegistrationStep) {
    RegistrationStep[RegistrationStep["FIRST_STEP"] = 1] = "FIRST_STEP";
    RegistrationStep[RegistrationStep["SECOND_STEP"] = 2] = "SECOND_STEP";
    RegistrationStep[RegistrationStep["SUCCESS_REGISTRATION"] = 10] = "SUCCESS_REGISTRATION";
    RegistrationStep[RegistrationStep["RESEND_EMAIL"] = 11] = "RESEND_EMAIL";
    RegistrationStep[RegistrationStep["EMAIL_RESENT"] = 12] = "EMAIL_RESENT";
    RegistrationStep[RegistrationStep["EMAIL_CONFIRMED"] = 13] = "EMAIL_CONFIRMED";
})(RegistrationStep || (RegistrationStep = {}));
